import type { ReactNode } from 'react';
import { Card } from '@ksyos/design-system';
import { EmptyListPlaceholder } from '@frontend/components/elements/EmptyListPlaceholder';
import { MonitoringLoader } from './MonitoringLoader';

type MonitoringCardProps = {
    children: ReactNode;
    emptyTitle: string;
    isEmpty: boolean;
    isLoading: boolean;
};

export function MonitoringCard(props: MonitoringCardProps): JSX.Element {
    const { children, emptyTitle, isEmpty, isLoading } = props;

    if (isLoading) {
        return (
            <Card>
                <Card.Body>
                    <MonitoringLoader />
                </Card.Body>
            </Card>
        );
    }

    if (isEmpty) {
        return <EmptyListPlaceholder subtitle={emptyTitle} />;
    }

    return <Card>{children}</Card>;
}
